import React from 'react'
import { Form, Button, Cascader } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'

const deviceDisplayRender = (labels: string[], selectedOptions?: any[]) => {
  if (!selectedOptions || selectedOptions.length < 2) return labels.join(' / ')

  const device = selectedOptions[1]
  return device?.selectedLabel
}

const SecurityDeviceSelector: React.FC<{ dataOptions?: any }> = ({ dataOptions }) => (
  <Wrapper>
    <div className="form-item-wrapper">
      <Form.Item label={t('安全设备')} name="deviceIds">
        <Cascader
          placeholder={t('请选择')}
          options={dataOptions?.deviceOptions || []}
          style={{ width: 720 }}
          displayRender={deviceDisplayRender}
        />
      </Form.Item>
      <Button type="link" onClick={() => window.open('/configure/device/access-management')}>
        {t('添加接入设备')}
      </Button>
    </div>
  </Wrapper>
)

export default SecurityDeviceSelector

const Wrapper = styled.div`
  margin-bottom: 16px;
  margin-left: 120px;

  .form-item-wrapper {
    display: flex;

    .ant-form-item {
      margin-bottom: 0;
    }

    .ant-btn {
      margin-left: 16px;
      padding: 6.6px 0;
    }
  }
`
